function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useState, useRef, useCallback, useMemo, Fragment } from 'react';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import { PlayCircle, Clock, Settings, FileText, ListChecks, AlertTriangle } from 'lucide-react';
import { unified } from 'unified';
import remarkParse from 'remark-parse';
import remarkGfm from 'remark-gfm';
import remarkRehype from 'remark-rehype';
import rehypeReact from 'rehype-react';
import { jsx, jsxs } from 'react/jsx-runtime';
// --- Styled Components ---
var PracticeContainer = styled.div(function(param) {
    var theme = param.theme;
    var _theme_colors, _theme_radius, _theme_spacing, _theme_spacing1, _theme_colors1, _theme_shadows, _theme_breakpoints, _theme_spacing2, _theme_spacing3, _theme_spacing4, _theme_colors2, _theme_colors3;
    return _define_property({
        borderLeft: "4px solid ".concat(((_theme_colors = theme.colors) === null || _theme_colors === void 0 ? void 0 : _theme_colors.primary) || '#3b82f6'),
        borderRadius: ((_theme_radius = theme.radius) === null || _theme_radius === void 0 ? void 0 : _theme_radius.md) || '0.5rem',
        padding: ((_theme_spacing = theme.spacing) === null || _theme_spacing === void 0 ? void 0 : _theme_spacing.lg) || '1.5rem',
        margin: "".concat(((_theme_spacing1 = theme.spacing) === null || _theme_spacing1 === void 0 ? void 0 : _theme_spacing1.lg) || '1.5rem', " 0"),
        backgroundColor: ((_theme_colors1 = theme.colors) === null || _theme_colors1 === void 0 ? void 0 : _theme_colors1.background) || '#ffffff',
        boxShadow: ((_theme_shadows = theme.shadows) === null || _theme_shadows === void 0 ? void 0 : _theme_shadows.sm) || '0 1px 3px rgba(0,0,0,0.1)'
    }, "@media (max-width: ".concat(((_theme_breakpoints = theme.breakpoints) === null || _theme_breakpoints === void 0 ? void 0 : _theme_breakpoints.sm) || '640px', ")"), {
        padding: "".concat(((_theme_spacing2 = theme.spacing) === null || _theme_spacing2 === void 0 ? void 0 : _theme_spacing2.xs) || '0.25rem', " ").concat(((_theme_spacing3 = theme.spacing) === null || _theme_spacing3 === void 0 ? void 0 : _theme_spacing3.xs) || '0.25rem'),
        margin: "".concat(((_theme_spacing4 = theme.spacing) === null || _theme_spacing4 === void 0 ? void 0 : _theme_spacing4.xs) || '0.25rem', " 0"),
        borderRadius: 0,
        borderLeft: "2px solid ".concat(((_theme_colors2 = theme.colors) === null || _theme_colors2 === void 0 ? void 0 : _theme_colors2.primary) || '#3b82f6'),
        boxShadow: 'none',
        borderBottom: "1px solid ".concat(((_theme_colors3 = theme.colors) === null || _theme_colors3 === void 0 ? void 0 : _theme_colors3.border) || '#e5e7eb')
    });
});
var Header = styled.h3(function(param) {
    var theme = param.theme;
    var _theme_spacing, _theme_spacing1, _theme_colors, _theme_typography_fontSize, _theme_typography, _theme_breakpoints, _theme_typography_fontSize1, _theme_typography1, _theme_spacing2, _theme_spacing3;
    return _define_property({
        display: 'flex',
        alignItems: 'center',
        gap: ((_theme_spacing = theme.spacing) === null || _theme_spacing === void 0 ? void 0 : _theme_spacing.sm) || '0.5rem',
        marginTop: 0,
        marginBottom: ((_theme_spacing1 = theme.spacing) === null || _theme_spacing1 === void 0 ? void 0 : _theme_spacing1.md) || '1rem',
        color: ((_theme_colors = theme.colors) === null || _theme_colors === void 0 ? void 0 : _theme_colors.primary) || '#3b82f6',
        fontSize: ((_theme_typography = theme.typography) === null || _theme_typography === void 0 ? void 0 : (_theme_typography_fontSize = _theme_typography.fontSize) === null || _theme_typography_fontSize === void 0 ? void 0 : _theme_typography_fontSize.lg) || '1.125rem'
    }, "@media (max-width: ".concat(((_theme_breakpoints = theme.breakpoints) === null || _theme_breakpoints === void 0 ? void 0 : _theme_breakpoints.sm) || '640px', ")"), {
        fontSize: ((_theme_typography1 = theme.typography) === null || _theme_typography1 === void 0 ? void 0 : (_theme_typography_fontSize1 = _theme_typography1.fontSize) === null || _theme_typography_fontSize1 === void 0 ? void 0 : _theme_typography_fontSize1.base) || '1rem',
        gap: ((_theme_spacing2 = theme.spacing) === null || _theme_spacing2 === void 0 ? void 0 : _theme_spacing2.xs) || '0.25rem',
        marginBottom: ((_theme_spacing3 = theme.spacing) === null || _theme_spacing3 === void 0 ? void 0 : _theme_spacing3.xs) || '0.25rem'
    });
});
var PracticeTypeHeader = styled.div(function(param) {
    var theme = param.theme;
    var _theme_spacing, _theme_spacing1, _theme_spacing2, _theme_colors, _theme_colors1, _theme_colors2, _theme_colors3, _theme_typography_fontSize, _theme_typography, _theme_typography_fontWeight, _theme_typography1, _theme_breakpoints, _theme_spacing3, _theme_spacing4, _theme_typography_fontSize1, _theme_typography2, _theme_spacing5;
    return _define_property({
        padding: "".concat(((_theme_spacing = theme.spacing) === null || _theme_spacing === void 0 ? void 0 : _theme_spacing.sm) || '0.5rem', " ").concat(((_theme_spacing1 = theme.spacing) === null || _theme_spacing1 === void 0 ? void 0 : _theme_spacing1.lg) || '1.5rem'),
        marginBottom: ((_theme_spacing2 = theme.spacing) === null || _theme_spacing2 === void 0 ? void 0 : _theme_spacing2.lg) || '1.5rem',
        backgroundColor: ((_theme_colors = theme.colors) === null || _theme_colors === void 0 ? void 0 : _theme_colors.muted) || '#f3f4f6',
        borderBottom: "1px solid ".concat(((_theme_colors1 = theme.colors) === null || _theme_colors1 === void 0 ? void 0 : _theme_colors1.border) || '#e5e7eb'),
        borderTop: "1px solid ".concat(((_theme_colors2 = theme.colors) === null || _theme_colors2 === void 0 ? void 0 : _theme_colors2.border) || '#e5e7eb'),
        textAlign: 'center',
        color: ((_theme_colors3 = theme.colors) === null || _theme_colors3 === void 0 ? void 0 : _theme_colors3.mutedText) || '#6b7280',
        fontSize: ((_theme_typography = theme.typography) === null || _theme_typography === void 0 ? void 0 : (_theme_typography_fontSize = _theme_typography.fontSize) === null || _theme_typography_fontSize === void 0 ? void 0 : _theme_typography_fontSize.sm) || '0.875rem',
        fontWeight: ((_theme_typography1 = theme.typography) === null || _theme_typography1 === void 0 ? void 0 : (_theme_typography_fontWeight = _theme_typography1.fontWeight) === null || _theme_typography_fontWeight === void 0 ? void 0 : _theme_typography_fontWeight.medium) || 500
    }, "@media (max-width: ".concat(((_theme_breakpoints = theme.breakpoints) === null || _theme_breakpoints === void 0 ? void 0 : _theme_breakpoints.sm) || '640px', ")"), {
        padding: "".concat(((_theme_spacing3 = theme.spacing) === null || _theme_spacing3 === void 0 ? void 0 : _theme_spacing3.xs) || '0.25rem', " ").concat(((_theme_spacing4 = theme.spacing) === null || _theme_spacing4 === void 0 ? void 0 : _theme_spacing4.sm) || '0.5rem'),
        fontSize: ((_theme_typography2 = theme.typography) === null || _theme_typography2 === void 0 ? void 0 : (_theme_typography_fontSize1 = _theme_typography2.fontSize) === null || _theme_typography_fontSize1 === void 0 ? void 0 : _theme_typography_fontSize1.xs) || '0.75rem',
        marginBottom: ((_theme_spacing5 = theme.spacing) === null || _theme_spacing5 === void 0 ? void 0 : _theme_spacing5.sm) || '0.5rem'
    });
});
var Section = styled.div(function(param) {
    var theme = param.theme;
    var _theme_spacing, _theme_breakpoints, _theme_spacing1;
    return _define_property({
        marginBottom: ((_theme_spacing = theme.spacing) === null || _theme_spacing === void 0 ? void 0 : _theme_spacing.lg) || '1.5rem'
    }, "@media (max-width: ".concat(((_theme_breakpoints = theme.breakpoints) === null || _theme_breakpoints === void 0 ? void 0 : _theme_breakpoints.sm) || '640px', ")"), {
        marginBottom: ((_theme_spacing1 = theme.spacing) === null || _theme_spacing1 === void 0 ? void 0 : _theme_spacing1.xs) || '0.25rem'
    });
});
var SectionTitle = styled.h4(function(param) {
    var theme = param.theme;
    var _theme_spacing, _theme_spacing1, _theme_typography_fontWeight, _theme_typography, _theme_colors, _theme_typography_fontSize, _theme_typography1, _theme_breakpoints, _theme_typography_fontSize1, _theme_typography2, _theme_spacing2, _theme_spacing3;
    return _define_property({
        display: 'flex',
        alignItems: 'center',
        gap: ((_theme_spacing = theme.spacing) === null || _theme_spacing === void 0 ? void 0 : _theme_spacing.sm) || '0.5rem',
        marginBottom: ((_theme_spacing1 = theme.spacing) === null || _theme_spacing1 === void 0 ? void 0 : _theme_spacing1.sm) || '0.5rem',
        fontWeight: ((_theme_typography = theme.typography) === null || _theme_typography === void 0 ? void 0 : (_theme_typography_fontWeight = _theme_typography.fontWeight) === null || _theme_typography_fontWeight === void 0 ? void 0 : _theme_typography_fontWeight.semibold) || 600,
        color: ((_theme_colors = theme.colors) === null || _theme_colors === void 0 ? void 0 : _theme_colors.text) || '#1f2937',
        fontSize: ((_theme_typography1 = theme.typography) === null || _theme_typography1 === void 0 ? void 0 : (_theme_typography_fontSize = _theme_typography1.fontSize) === null || _theme_typography_fontSize === void 0 ? void 0 : _theme_typography_fontSize.base) || '1rem'
    }, "@media (max-width: ".concat(((_theme_breakpoints = theme.breakpoints) === null || _theme_breakpoints === void 0 ? void 0 : _theme_breakpoints.sm) || '640px', ")"), {
        fontSize: ((_theme_typography2 = theme.typography) === null || _theme_typography2 === void 0 ? void 0 : (_theme_typography_fontSize1 = _theme_typography2.fontSize) === null || _theme_typography_fontSize1 === void 0 ? void 0 : _theme_typography_fontSize1.sm) || '0.875rem',
        gap: ((_theme_spacing2 = theme.spacing) === null || _theme_spacing2 === void 0 ? void 0 : _theme_spacing2.xs) || '0.25rem',
        marginBottom: ((_theme_spacing3 = theme.spacing) === null || _theme_spacing3 === void 0 ? void 0 : _theme_spacing3.xs) || '0.25rem'
    });
});
var MarkdownContentWrapper = styled.div(function(param) {
    var theme = param.theme;
    var _theme_colors, _theme_colors1, _theme_radius, _theme_spacing, _theme_typography_fontSize, _theme_typography, _theme_colors2, _theme_spacing1, _theme_spacing2, _theme_spacing3, _theme_spacing4, _theme_spacing5, _theme_spacing6, _theme_colors3, _theme_radius1, _theme_breakpoints, _theme_spacing7, _theme_typography_fontSize1, _theme_typography1;
    return _define_property({
        backgroundColor: ((_theme_colors = theme.colors) === null || _theme_colors === void 0 ? void 0 : _theme_colors.muted) || '#f9fafb',
        border: "1px solid ".concat(((_theme_colors1 = theme.colors) === null || _theme_colors1 === void 0 ? void 0 : _theme_colors1.border) || '#e5e7eb'),
        borderRadius: ((_theme_radius = theme.radius) === null || _theme_radius === void 0 ? void 0 : _theme_radius.sm) || '0.375rem',
        padding: ((_theme_spacing = theme.spacing) === null || _theme_spacing === void 0 ? void 0 : _theme_spacing.md) || '1rem',
        fontSize: ((_theme_typography = theme.typography) === null || _theme_typography === void 0 ? void 0 : (_theme_typography_fontSize = _theme_typography.fontSize) === null || _theme_typography_fontSize === void 0 ? void 0 : _theme_typography_fontSize.sm) || '0.875rem',
        color: ((_theme_colors2 = theme.colors) === null || _theme_colors2 === void 0 ? void 0 : _theme_colors2.mutedText) || '#6b7280',
        lineHeight: 1.6,
        ul: {
            paddingLeft: ((_theme_spacing1 = theme.spacing) === null || _theme_spacing1 === void 0 ? void 0 : _theme_spacing1.lg) || '1.5rem',
            margin: "".concat(((_theme_spacing2 = theme.spacing) === null || _theme_spacing2 === void 0 ? void 0 : _theme_spacing2.sm) || '0.5rem', " 0")
        },
        ol: {
            paddingLeft: ((_theme_spacing3 = theme.spacing) === null || _theme_spacing3 === void 0 ? void 0 : _theme_spacing3.lg) || '1.5rem',
            margin: "".concat(((_theme_spacing4 = theme.spacing) === null || _theme_spacing4 === void 0 ? void 0 : _theme_spacing4.sm) || '0.5rem', " 0")
        },
        li: {
            marginBottom: ((_theme_spacing5 = theme.spacing) === null || _theme_spacing5 === void 0 ? void 0 : _theme_spacing5.xs) || '0.25rem'
        },
        p: {
            marginBottom: ((_theme_spacing6 = theme.spacing) === null || _theme_spacing6 === void 0 ? void 0 : _theme_spacing6.sm) || '0.5rem',
            '&:last-child': {
                marginBottom: 0
            }
        },
        code: {
            backgroundColor: ((_theme_colors3 = theme.colors) === null || _theme_colors3 === void 0 ? void 0 : _theme_colors3.codeBg) || '#e5e7eb',
            padding: '0.2em 0.4em',
            borderRadius: ((_theme_radius1 = theme.radius) === null || _theme_radius1 === void 0 ? void 0 : _theme_radius1.sm) || '0.375rem',
            fontSize: '0.9em',
            fontFamily: 'monospace'
        }
    }, "@media (max-width: ".concat(((_theme_breakpoints = theme.breakpoints) === null || _theme_breakpoints === void 0 ? void 0 : _theme_breakpoints.sm) || '640px', ")"), {
        padding: ((_theme_spacing7 = theme.spacing) === null || _theme_spacing7 === void 0 ? void 0 : _theme_spacing7.xs) || '0.25rem',
        fontSize: ((_theme_typography1 = theme.typography) === null || _theme_typography1 === void 0 ? void 0 : (_theme_typography_fontSize1 = _theme_typography1.fontSize) === null || _theme_typography_fontSize1 === void 0 ? void 0 : _theme_typography_fontSize1.xs) || '0.75rem'
    });
});
var StartButton = styled.button(function(param) {
    var theme = param.theme;
    var _theme_colors, _theme_spacing, _theme_spacing1, _theme_radius, _theme_typography_fontSize, _theme_typography, _theme_typography_fontWeight, _theme_typography1, _theme_spacing2, _theme_spacing3, _theme_colors1, _theme_colors2;
    return {
        backgroundColor: ((_theme_colors = theme.colors) === null || _theme_colors === void 0 ? void 0 : _theme_colors.primary) || '#3b82f6',
        color: '#ffffff',
        border: 'none',
        padding: "".concat(((_theme_spacing = theme.spacing) === null || _theme_spacing === void 0 ? void 0 : _theme_spacing.sm) || '0.5rem', " ").concat(((_theme_spacing1 = theme.spacing) === null || _theme_spacing1 === void 0 ? void 0 : _theme_spacing1.lg) || '1.5rem'),
        borderRadius: ((_theme_radius = theme.radius) === null || _theme_radius === void 0 ? void 0 : _theme_radius.md) || '0.5rem',
        cursor: 'pointer',
        fontSize: ((_theme_typography = theme.typography) === null || _theme_typography === void 0 ? void 0 : (_theme_typography_fontSize = _theme_typography.fontSize) === null || _theme_typography_fontSize === void 0 ? void 0 : _theme_typography_fontSize.base) || '1rem',
        fontWeight: ((_theme_typography1 = theme.typography) === null || _theme_typography1 === void 0 ? void 0 : (_theme_typography_fontWeight = _theme_typography1.fontWeight) === null || _theme_typography_fontWeight === void 0 ? void 0 : _theme_typography_fontWeight.semibold) || 600,
        display: 'inline-flex',
        alignItems: 'center',
        gap: ((_theme_spacing2 = theme.spacing) === null || _theme_spacing2 === void 0 ? void 0 : _theme_spacing2.xs) || '0.25rem',
        transition: 'background-color 200ms',
        marginTop: ((_theme_spacing3 = theme.spacing) === null || _theme_spacing3 === void 0 ? void 0 : _theme_spacing3.md) || '1rem',
        '&:hover:not(:disabled)': {
            backgroundColor: ((_theme_colors1 = theme.colors) === null || _theme_colors1 === void 0 ? void 0 : _theme_colors1.primaryDark) || '#2563eb'
        },
        '&:disabled': {
            backgroundColor: ((_theme_colors2 = theme.colors) === null || _theme_colors2 === void 0 ? void 0 : _theme_colors2.disabled) || '#9ca3af',
            cursor: 'not-allowed',
            opacity: 0.7
        }
    };
});
var TimerDisplay = styled.div(function(param) {
    var theme = param.theme, timeUp = param.timeUp;
    var _theme_typography_fontSize, _theme_typography, _theme_typography_fontWeight, _theme_typography1, _theme_colors, _theme_colors1, _theme_spacing, _theme_spacing1, _theme_colors2, _theme_radius, _theme_colors3, _theme_colors4, _theme_spacing2;
    return {
        fontSize: ((_theme_typography = theme.typography) === null || _theme_typography === void 0 ? void 0 : (_theme_typography_fontSize = _theme_typography.fontSize) === null || _theme_typography_fontSize === void 0 ? void 0 : _theme_typography_fontSize.xl) || '1.25rem',
        fontWeight: ((_theme_typography1 = theme.typography) === null || _theme_typography1 === void 0 ? void 0 : (_theme_typography_fontWeight = _theme_typography1.fontWeight) === null || _theme_typography_fontWeight === void 0 ? void 0 : _theme_typography_fontWeight.bold) || 700,
        color: timeUp ? ((_theme_colors = theme.colors) === null || _theme_colors === void 0 ? void 0 : _theme_colors.error) || '#ef4444' : ((_theme_colors1 = theme.colors) === null || _theme_colors1 === void 0 ? void 0 : _theme_colors1.success) || '#10b981',
        marginTop: ((_theme_spacing = theme.spacing) === null || _theme_spacing === void 0 ? void 0 : _theme_spacing.lg) || '1.5rem',
        textAlign: 'center',
        padding: ((_theme_spacing1 = theme.spacing) === null || _theme_spacing1 === void 0 ? void 0 : _theme_spacing1.md) || '1rem',
        backgroundColor: ((_theme_colors2 = theme.colors) === null || _theme_colors2 === void 0 ? void 0 : _theme_colors2.muted) || '#f9fafb',
        borderRadius: ((_theme_radius = theme.radius) === null || _theme_radius === void 0 ? void 0 : _theme_radius.sm) || '0.375rem',
        border: "1px solid ".concat(timeUp ? ((_theme_colors3 = theme.colors) === null || _theme_colors3 === void 0 ? void 0 : _theme_colors3.error) || '#ef4444' : ((_theme_colors4 = theme.colors) === null || _theme_colors4 === void 0 ? void 0 : _theme_colors4.success) || '#10b981'),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: ((_theme_spacing2 = theme.spacing) === null || _theme_spacing2 === void 0 ? void 0 : _theme_spacing2.sm) || '0.5rem'
    };
});
// --- Component ---
var PracticeBlock = function(param) {
    var practiceDetails = param.practiceDetails, children = param.children;
    var _theme_spacing, _theme_typography_fontSize, _theme_typography, _theme_colors;
    var theme = useTheme();
    var _useState = _sliced_to_array(useState(false), 2), isRunning = _useState[0], setIsRunning = _useState[1];
    var _useState1 = _sliced_to_array(useState(practiceDetails ? practiceDetails.timeLimit * 60 : null), 2), timeLeft = _useState1[0], setTimeLeft = _useState1[1];
    var timerRef = useRef(null);
    // Markdown processor setup
    var markdownProcessor = useMemo(function() {
        var componentMap = {
            p: 'p',
            ul: 'ul',
            ol: 'ol',
            li: 'li',
            code: function(props) {
                var className = props.className, children = props.children, rest = _object_without_properties(props, [
                    "className",
                    "children"
                ]);
                var isInline = !(className === null || className === void 0 ? void 0 : className.startsWith('language-'));
                if (isInline) {
                    var _theme_colors, _theme_radius;
                    return /*#__PURE__*/ React.createElement("code", _object_spread({
                        style: {
                            backgroundColor: ((_theme_colors = theme.colors) === null || _theme_colors === void 0 ? void 0 : _theme_colors.codeBg) || '#e5e7eb',
                            padding: '0.2em 0.4em',
                            borderRadius: ((_theme_radius = theme.radius) === null || _theme_radius === void 0 ? void 0 : _theme_radius.sm) || '0.375rem',
                            fontSize: '0.9em'
                        },
                        className: className
                    }, rest), children);
                }
                return /*#__PURE__*/ React.createElement("code", _object_spread({
                    className: className
                }, rest), children);
            },
            strong: 'strong',
            em: 'em'
        };
        return unified().use(remarkParse).use(remarkGfm).use(remarkRehype).use(rehypeReact, {
            Fragment: Fragment,
            jsx: jsx,
            jsxs: jsxs,
            components: componentMap
        });
    }, [
        theme
    ]);
    var startTimer = useCallback(function() {
        if (!practiceDetails) return;
        setIsRunning(true);
        setTimeLeft(practiceDetails.timeLimit * 60);
        timerRef.current = setInterval(function() {
            setTimeLeft(function(prevTime) {
                if (prevTime === null || prevTime <= 1) {
                    if (timerRef.current) {
                        clearInterval(timerRef.current);
                        timerRef.current = null;
                    }
                    setIsRunning(false);
                    return 0;
                }
                return prevTime - 1;
            });
        }, 1000);
    }, [
        practiceDetails
    ]);
    var handleStartPractice = function() {
        if (!practiceDetails || isRunning) return;
        startTimer();
    };
    var formatTime = function(seconds) {
        if (seconds === null) return '00:00';
        var mins = Math.floor(seconds / 60);
        var secs = seconds % 60;
        return "".concat(String(mins).padStart(2, '0'), ":").concat(String(secs).padStart(2, '0'));
    };
    var renderMarkdown = function(markdownString) {
        try {
            var result = markdownProcessor.processSync(markdownString).result;
            if (!/*#__PURE__*/ React.isValidElement(result)) {
                return /*#__PURE__*/ React.createElement(React.Fragment, null, markdownString);
            }
            return result;
        } catch (error) {
            console.error("Markdown processing error:", error);
            return /*#__PURE__*/ React.createElement(React.Fragment, null, markdownString);
        }
    };
    var isTimeUp = timeLeft === 0;
    // Use children if provided, otherwise render practice details
    if (children) {
        return /*#__PURE__*/ React.createElement(PracticeContainer, null, children);
    }
    if (!practiceDetails) {
        return null;
    }
    var _practiceDetails_practiceType;
    return /*#__PURE__*/ React.createElement(PracticeContainer, null, /*#__PURE__*/ React.createElement(Header, null, /*#__PURE__*/ React.createElement(PlayCircle, {
        size: 20
    }), /*#__PURE__*/ React.createElement("span", null, (_practiceDetails_practiceType = practiceDetails.practiceType) !== null && _practiceDetails_practiceType !== void 0 ? _practiceDetails_practiceType : '실습 문제')), /*#__PURE__*/ React.createElement(PracticeTypeHeader, null, practiceDetails.problemDescription.split('\n')[0]), /*#__PURE__*/ React.createElement(Section, null, /*#__PURE__*/ React.createElement(SectionTitle, null, /*#__PURE__*/ React.createElement(Clock, {
        size: 16
    }), /*#__PURE__*/ React.createElement("span", null, "제한 시간")), /*#__PURE__*/ React.createElement("p", {
        style: {
            paddingLeft: ((_theme_spacing = theme.spacing) === null || _theme_spacing === void 0 ? void 0 : _theme_spacing.lg) || '1.5rem',
            fontSize: ((_theme_typography = theme.typography) === null || _theme_typography === void 0 ? void 0 : (_theme_typography_fontSize = _theme_typography.fontSize) === null || _theme_typography_fontSize === void 0 ? void 0 : _theme_typography_fontSize.sm) || '0.875rem',
            color: ((_theme_colors = theme.colors) === null || _theme_colors === void 0 ? void 0 : _theme_colors.mutedText) || '#6b7280'
        }
    }, practiceDetails.timeLimit, "분")), /*#__PURE__*/ React.createElement(Section, null, /*#__PURE__*/ React.createElement(SectionTitle, null, /*#__PURE__*/ React.createElement(Settings, {
        size: 16
    }), /*#__PURE__*/ React.createElement("span", null, "환경 설정")), /*#__PURE__*/ React.createElement(MarkdownContentWrapper, null, renderMarkdown(practiceDetails.setupInstructions))), /*#__PURE__*/ React.createElement(Section, null, /*#__PURE__*/ React.createElement(SectionTitle, null, /*#__PURE__*/ React.createElement(FileText, {
        size: 16
    }), /*#__PURE__*/ React.createElement("span", null, "문제 설명")), /*#__PURE__*/ React.createElement(MarkdownContentWrapper, null, renderMarkdown(practiceDetails.problemDescription))), /*#__PURE__*/ React.createElement(Section, null, /*#__PURE__*/ React.createElement(SectionTitle, null, /*#__PURE__*/ React.createElement(ListChecks, {
        size: 16
    }), /*#__PURE__*/ React.createElement("span", null, "요구 사항")), /*#__PURE__*/ React.createElement(MarkdownContentWrapper, null, renderMarkdown(practiceDetails.requirements))), !isRunning && !isTimeUp && /*#__PURE__*/ React.createElement("div", {
        style: {
            textAlign: 'center'
        }
    }, /*#__PURE__*/ React.createElement(StartButton, {
        onClick: handleStartPractice
    }, /*#__PURE__*/ React.createElement(PlayCircle, {
        size: 16
    }), " 실습 시작하기")), (isRunning || isTimeUp) && /*#__PURE__*/ React.createElement(TimerDisplay, {
        timeUp: isTimeUp
    }, isTimeUp ? /*#__PURE__*/ React.createElement(AlertTriangle, {
        size: 24
    }) : /*#__PURE__*/ React.createElement(Clock, {
        size: 24
    }), /*#__PURE__*/ React.createElement("span", null, isTimeUp ? '시간 종료!' : "남은 시간: ".concat(formatTime(timeLeft)))));
};
export default PracticeBlock;
